export class PerguntaFrequenteInputDto {
  public TextoPesquisa?: string;

  constructor(pesquisa: string){
    this.TextoPesquisa = pesquisa;
  }
}
